import { render, staticRenderFns } from "./FeedbackGift.vue?vue&type=template&id=2e2d03db&scoped=true&"
import script from "./FeedbackGift.vue?vue&type=script&lang=js&"
export * from "./FeedbackGift.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackGift.vue?vue&type=style&index=0&id=2e2d03db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2d03db",
  null
  
)

component.options.__file = "FeedbackGift.vue"
export default component.exports